export default __webpack_public_path__ + "static/media/Upload-icon.ab8ab98d.svg";